import React from 'react';
import { FsDirection } from 'globals/types';
import useTheme from '@material-ui/core/styles/useTheme';
import { purple } from 'globals/colors';

interface FsVectorArrowSmallIconProps {
  color?: string;
  direction?: FsDirection;
  disabled?: boolean;
}

const getRotationDegree = (direction: FsDirection): string => {
  switch (direction) {
    case FsDirection.LEFT:
      return '0deg';
    case FsDirection.UP:
      return '90deg';
    case FsDirection.RIGHT:
      return '180deg';
    case FsDirection.DOWN:
      return '270deg';
    default:
      return '0deg';
  }
};

const FsVectorArrowSmallIcon: React.FC<FsVectorArrowSmallIconProps> = ({
  color = purple.BRAND,
  direction = FsDirection.RIGHT,
  disabled,
}) => {
  const { palette } = useTheme();
  const activeColor = disabled ? palette.grey[200] : color;
  const rotationDegree = getRotationDegree(direction);
  return (
    <>
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          transform: `rotate(${rotationDegree})`,
        }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.29304 0.292969L7.70726 1.70718L3.41436 6.00008L7.70726 10.293L6.29304 11.7072L0.585938 6.00008L6.29304 0.292969Z"
          fill={activeColor}
        />
      </svg>
    </>
  );
};

export default FsVectorArrowSmallIcon;
